import { Platform } from 'react-native';
export async function getAnalyticsIdentity(): Promise<{
  platform: 'ios' | 'android';
  appInstanceId: string;
} | null> {
  if (Platform.OS === 'web') return null;
  try {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const native = require('./firebase-analytics') as {
      getNativeAnalyticsIdentity: () => Promise<{
        platform: 'ios' | 'android';
        appInstanceId: string;
      } | null>;
    };
    return await native.getNativeAnalyticsIdentity();
  } catch {
    return null;
  }
}

export function getCachedAnalyticsIdentity(): {
  platform: 'ios' | 'android';
  appInstanceId: string;
} | null {
  if (Platform.OS === 'web') return null;
  try {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    return require('./firebase-analytics').getCachedNativeAnalyticsIdentity();
  } catch {
    return null;
  }
}
